const OWNER = 'OWNER'
const ADMIN = 'ADMIN'
const USER = 'USER'

export const ORDERED_ROLES = [USER, ADMIN, OWNER]

export const yesNoOptions = ['yes', 'no']
export const clubTypes = ['none', 'vip', 'vip_plus']
export const clubPeriods = ['monthly', 'yearly']
